import React, { memo } from 'react'
import styled from 'styled-components/native'
import { Avatar } from 'APP/Converse/Avatar'
import Typography from 'APP/Converse/Typography'
import { DescriptionStyle } from 'APP/Services/Mattermost/types'
import { Images } from 'APP/Themes'
import { QuestionDescriptionProps } from './types'

const Card = styled.View`
  background-color: ${({ theme }) => theme.colors.clientCardBg};
  border-radius: ${({ theme }) => theme.metrics.baseMargin}px;
  padding: ${({ theme }) =>
    `${theme.metrics.baseMargin}px ${theme.metrics.baseMargin}px ${
      theme.metrics.baseMargin / 2
    }px`};
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

const Header = styled.View`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  align-items: center;
`

const HeaderText = styled(Typography)`
  flex: 1;
`

const Container = styled.View`
  flex-shrink: 3;
  flex-grow: 0;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const QuestionDescription = memo<QuestionDescriptionProps>(
  ({ children, member_app_fullscreen }) => {
    switch (member_app_fullscreen?.description_style) {
      case DescriptionStyle.card:
        return (
          <Container>
            <Card>
              <Header>
                <Avatar size="regular" source={Images.avatarDialogue} resizeMode="contain" />
                <HeaderText variant="h3">{member_app_fullscreen.description_heading}</HeaderText>
              </Header>
              {children}
            </Card>
          </Container>
        )
      default:
        return <Container>{children}</Container>
    }
  }
)
